import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {Power1, TimelineLite, TweenLite} from "gsap";
import {IBonusSymbolQueue} from "../../server/data/IBonusSymbolQueue";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {BonusBunniesGameModuleConfig} from "../../BonusBunniesGameModuleConfig";
import {BonusBunniesStickyBonusValueContainer} from "../../winpresentation/stickybonusvalues/BonusBunniesStickyBonusValueContainer";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";

/**
 * Created by Jerker Nord on 2019-09-04.
 */

export class BonusBunniesHarvesterWinView extends BaseView {

    protected _layer:ScalableLayer;
    private _collectAnimationDelay:number = -0.3;
    private _animationCounter:number = 0;
    private _upgradeSound:string[] = [BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_REEL_1,
        BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_REEL_2];
    private _currentUpgradeSound:number = 0;

    constructor() {
        super();
        this._layer = StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BASE_FEATURE.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {

    }

    public harvesterCollectAnimation(harvesterWins:IBonusSymbolQueue):TimelineLite {
        const collectMainAnimationTL:TimelineLite = new TimelineLite();
        const targetPosition:PIXI.Point = new PIXI.Point(Helper.getSymbolPositions(harvesterWins.reelPos, harvesterWins.rowPos)[0], Helper.getSymbolPositions(harvesterWins.reelPos, harvesterWins.rowPos)[1]);
        const activeBonusValues:BonusBunniesStickyBonusValueContainer[] = BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.getAllActiveBonusValues();
        const collectAnimations:TimelineLite[] = [];
        for(let j:number = 0; j < activeBonusValues.length; j++) {
            if(activeBonusValues[j].reel == harvesterWins.reelPos && activeBonusValues[j].row == harvesterWins.rowPos) {
                //Don't collect yourself
            } else {
                const collectAnimation = new TimelineLite({delay : this.getCollectAnimationDelay(j)});
                collectAnimation.add(() => BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.moveValueContainerToTop(activeBonusValues[j]));
                collectAnimation.add(() => activeBonusValues[j].duplicateValueText.visible = true);
                collectAnimation.add([
                    () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_SWEEP),
                    () => BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.playVSymbolAnimation(activeBonusValues[j].reel, activeBonusValues[j].row, false),
                    new TweenLite(activeBonusValues[j].duplicateValueText.position, this.getValuesAnimationDuration(), {
                        x : targetPosition.x - 10,
                        y : targetPosition.y + 20,
                        ease : Power1.easeOut
                    }),
                    this.getNumberScaleTL(activeBonusValues[j])
                ]);
                collectAnimation.add(() => this.playUpgradeSound());
                collectAnimation.add(() => BonusBunniesGameModuleConfig.bonusBunniesValueSymbolReplacerView.playB2SymbolAnimation(harvesterWins.reelPos, harvesterWins.rowPos));
                collectAnimation.add(() => activeBonusValues[j].resetDuplicateValueText());
                collectAnimation.add(() => BonusBunniesGameModuleConfig.bonusBunniesStickyBonusWPView.addValueToStickyBonus(harvesterWins.reelPos, harvesterWins.rowPos, activeBonusValues[j].currentValue));
                collectAnimations.push(collectAnimation);
            }
        }

        collectMainAnimationTL.add(collectAnimations);
        collectMainAnimationTL.add(() => this._collectAnimationDelay = -0.3);
        this._collectAnimationDelay = -0.3;

        return collectMainAnimationTL;
    }

    private playUpgradeSound():void {
        SlotGame.sound.playEffect(this._upgradeSound[this._currentUpgradeSound]);
        this._currentUpgradeSound++;
        if(this._currentUpgradeSound == this._upgradeSound.length) {
            this._currentUpgradeSound = 0;
        }
    }

    private getValuesAnimationDuration():number {
        let duration:number = 0.4;
        if(this._animationCounter > 6) {
            duration = 0.2;
        } else if(this._animationCounter > 3) {
            duration = 0.3;
        }
        this._animationCounter++;
        return duration;
    }

    private getNumberScaleTL(valueContainer:BonusBunniesStickyBonusValueContainer):TimelineLite {
        const numberScaleTL:TimelineLite = new TimelineLite();
        numberScaleTL.add(new TweenLite(valueContainer.duplicateValueText.scale, 0.05, {
            x : 2,
            y : 2
        }));
        numberScaleTL.add(new TweenLite(valueContainer.duplicateValueText.scale, 0.1, {
            x : 1,
            y : 1
        }));
        return numberScaleTL;
    }

    getCollectAnimationDelay(animation:number):number {
        animation += this._animationCounter;
        if(animation > 6) {
            animation = 6;
        }
        let delay:number = 0.8 - (0.06 * animation);
        if(this._animationCounter > 6) {
            delay = 0.8 - (0.08 * animation);
        } else if(this._animationCounter > 3) {
            delay = 0.8 - (0.065 * animation);
        }

        if(delay <= 0) {
            delay = 1;
        }
        this._collectAnimationDelay += delay;
        return this._collectAnimationDelay;
    }

    set animationCounter(value:number) {
        this._animationCounter = value;
    }
}